export default ({g, line, data}) => {
  g.selectAll('.line')
      .data(data)
    .enter().append('path')
      .attr('class', d => `line line--${d.id}`)
      .attr('d', d => line(d.values))
}



// WEBPACK FOOTER //
// ./src/components/map-infobox/history-chart/draw_line.js